'use client';

import Logo from '@/components/common/Logo';
import LoginForm from '@/components/common/LoginForm';
import { loginUser } from '@/app/actions/user/auth/login';

const UserLoginPage = () => {
  return (
    <div className="min-h-screen bg-mono-10 flex flex-col items-center justify-start px-4 pt-[96px] pb-10 md:flex-row md:justify-center md:gap-[200px] md:px-[160px] md:py-0 md:items-center">
      {/* ロゴ（SP: 上部中央, PC: 左側） - ブレークポイント: 768px */}
      <div className="flex-shrink-0 mb-16 md:mb-0">
        <div className="block md:hidden">
          <Logo size="lg" />
        </div>
        <div className="hidden md:block">
          <Logo size="xl" />
        </div>
      </div>

      {/* ログインフォーム（SP: 下部全幅, PC: 右側固定幅） - ブレークポイント: 768px */}
      <div className="flex-shrink-0 w-full md:w-auto">
        <LoginForm
          userType="user"
          loginAction={loginUser}
          signupLink="/user/signup"
        />
      </div>
    </div>
  );
};

export default UserLoginPage;
